export default __webpack_public_path__ + "static/media/download.0b13ce69.svg";